/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseQuestion } from './CaseQuestion';
import {
	CaseQuestionFromJSON,
	CaseQuestionFromJSONTyped,
	CaseQuestionToJSON,
	CaseQuestionToJSONTyped,
} from './CaseQuestion';

/**
 *
 * @export
 * @interface CustomerJourneyQuestionsAnswersRequest
 */
export interface CustomerJourneyQuestionsAnswersRequest {
	/**
	 *
	 * @type {Array<CaseQuestion>}
	 * @memberof CustomerJourneyQuestionsAnswersRequest
	 */
	questions?: Array<CaseQuestion> | null;
}

/**
 * Check if a given object implements the CustomerJourneyQuestionsAnswersRequest interface.
 */
export function instanceOfCustomerJourneyQuestionsAnswersRequest(
	value: object
): value is CustomerJourneyQuestionsAnswersRequest {
	return true;
}

export function CustomerJourneyQuestionsAnswersRequestFromJSON(
	json: any
): CustomerJourneyQuestionsAnswersRequest {
	return CustomerJourneyQuestionsAnswersRequestFromJSONTyped(json, false);
}

export function CustomerJourneyQuestionsAnswersRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CustomerJourneyQuestionsAnswersRequest {
	if (json == null) {
		return json;
	}
	return {
		questions:
			json['questions'] == null
				? undefined
				: (json['questions'] as Array<any>).map(CaseQuestionFromJSON),
	};
}

export function CustomerJourneyQuestionsAnswersRequestToJSON(
	json: any
): CustomerJourneyQuestionsAnswersRequest {
	return CustomerJourneyQuestionsAnswersRequestToJSONTyped(json, false);
}

export function CustomerJourneyQuestionsAnswersRequestToJSONTyped(
	value?: CustomerJourneyQuestionsAnswersRequest | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		questions:
			value['questions'] == null
				? undefined
				: (value['questions'] as Array<any>).map(CaseQuestionToJSON),
	};
}
